// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u1OK","right":"styles_right__1zGU_"};